import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { areAllFeaturesEnabled } from './featureFlagAccess';
import { getRequiredFlagsForPath } from './routeFeatureMap';
import { useFeatureFlags } from './FeatureFlagsContext';

const FeatureFlagRedirect = () => {
  const location = useLocation();
  const { features, isReady } = useFeatureFlags();
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);

  if (!isReady) {
    return null;
  }

  const requiredFlags = getRequiredFlagsForPath(location.pathname);
  if (requiredFlags.length === 0) {
    return null;
  }

  if (areAllFeaturesEnabled(features, requiredFlags)) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Navigate to="/home" replace state={{ from: location.pathname }} />;
};

export default FeatureFlagRedirect;
